export default __webpack_public_path__ + "static/media/gold-chest-open-tab.5bae8415.png";